import { QueryClient } from '@tanstack/react-query';
import { type ReactElement } from 'react';

import { prepopulateCache } from '$shared/utils/react-query.utils';

import { createGetRunRecordReportQuery } from '$features/report-hub/run-record/run-record-detail.api';
import type { RunRecordReportDetailModel } from '$features/report-hub/run-record/run-record-detail.types';
import { RunRecordSidecar } from '$features/report-hub/run-record/run-record-sidecar';

export async function runRecordDetailLoader(
  queryClient: QueryClient,
  reportId: string,
): Promise<null> {
  return prepopulateCache<RunRecordReportDetailModel>(
    queryClient,
    createGetRunRecordReportQuery(reportId),
  );
}

export function RunRecordDetailPage(): ReactElement {
  return <RunRecordSidecar />;
}
